import { InferRequest, InferResponse } from '@/api/typedClient'
import { PaginationFilters, paginateData } from '@/api/utils'
import _ from 'lodash'

export type CreateUserPayload = InferRequest<'/meta/user/register'>
export type UpdateUserPayload = InferRequest<'/meta/user/update'>

export interface UserFilters extends PaginationFilters {
  search?: string
  role?: string
  status?: 'active' | 'inactive'
  limit?: number
  skip?: number
}

type UsersResponse = InferResponse<'/meta/user/all', 'post'>
export function filterAndPaginateUserResponse(
  filters: UserFilters,
  data: UsersResponse,
) {
  let filteredUsers = _.cloneDeep(data || [])

  if (filters.search) {
    const searchLower = filters.search.toLowerCase()
    filteredUsers = filteredUsers?.filter(
      (user) =>
        user.email?.toLowerCase().includes(searchLower) ||
        user.name?.toLowerCase().includes(searchLower),
    )
  }

  if (filters.status) {
    filteredUsers = filteredUsers?.filter((user) =>
      filters.status === 'inactive' ? !user.is_active : user.is_active,
    )
  }

  return paginateData(filteredUsers, filters)
}
